import React from "react";
import type { ReactNode } from "react";
import { useDropzone } from "react-dropzone";

interface UploadDropzoneProps {
  /**
   * Callback function to invoke when files are dropped.
   * Will not be called if `disabled` is `true`.
   */
  onDrop: (files: File[]) => void | Promise<void>;
  /**
   * Disables the dropzone and ignores dropped files.
   */
  disabled?: boolean;
  children?: ReactNode;
}

export default function UploadDropzone({
  onDrop,
  disabled,
  children,
}: UploadDropzoneProps) {
  const _onDrop = React.useCallback(
    async (files: File[]) => {
      if (disabled) return;
      await onDrop(files);
    },
    [disabled, onDrop]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: _onDrop,
    disabled,
    noClick: true,
    noKeyboard: true,
  });

  let overlayDivClass =
    "fixed top-0 left-0 w-100 h-100 bg-white-80 flex items-center justify-center z-9999";
  if (isDragActive === false) {
    overlayDivClass += " dn";
  }
  return (
    <div {...getRootProps()}>
      {children}
      <input {...getInputProps()} />
      {isDragActive && (
        <div className={overlayDivClass}>
          <div className="flex-row">
            <div className="mb2">
              Drop documents or images to add to the chat.
            </div>
            <div>(Only plain text, PDF, DOCX, PNG, or JPG files)</div>
          </div>
        </div>
      )}
    </div>
  );
}
